<template>
  <div>
    <v-tooltip top open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon @click.stop="abrirDialog()" v-bind="attrs" v-on="on">
          <v-icon small>mdi-information-outline</v-icon>
        </v-btn>
      </template>
      <span>Detalhamento do produto.</span>
    </v-tooltip>

    <v-dialog v-model="dialog" persistent  fullscreen transition="dialog-bottom-transition">
      <template v-slot:default>
        <div
          class="d-flex align-center justify-center height-full"
          style="background: rgba(0,0,0,.45)"
        >
          <div class="bg-white w-800px mx-aulto rounded">
            <v-card-title class="d-flex pa-2">
              <v-btn icon @click="fecharDialog" class="mr-4">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              Detalhamento do Produto {{ produto.filial == 9999 ? 'no Grupo' : `na Filial ${produto.filial}`}}
            </v-card-title>

            <v-divider />

            <detalhes-produto class="pl-5px w-full" elevation-hidden :produto="produto" />
          </div>
        </div>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import detalhesProduto from '../DetalhesProduto'
import CompraAPI from "../../../api/compra";

export default {
  name: 'DetalhesProdutoDialog',
  components: {detalhesProduto},
  props: {
    produto: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    fecharDialog () {
      this.dialog = false
    },
    abrirDialog () {
      this.buscarDetalhamentoProduto(this.produto)
    },
    buscarDetalhamentoProduto (item) {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        produto: item.idproduto,
        fornecedor: item.idfornecedor,
        grupo: item.id_grupo,
        filial: item.filial == 9999 ? 0 : item.filial
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getDetalhesProdutoGrupo(headers, params)
          .then((response) => {
            const {token, detalhe_ultima_compra, produto, estoque_filiais} = response.data;
            localStorage.setItem("token", token);
            this.$store.dispatch("detalhe_produto/setUltimaCompra", detalhe_ultima_compra);
            this.$store.dispatch("detalhe_produto/setProduto", produto);
            this.$store.dispatch("detalhe_produto/setEstoqueFiliais", estoque_filiais);

            this.dialog = true
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getAnaliseProdutoGrupo(headers, params)
          .then((response) => {
            const {token, data} = response.data;
            localStorage.setItem("token", token);
            this.$store.dispatch("detalhe_produto/setAnalise", data);
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getAnaliseTendenciaGrupo(headers, params)
          .then((response) => {
            const {token, data} = response.data;
            localStorage.setItem("token", token);
            this.$store.dispatch("fornecedor/setAnaliseTendencia", {data});
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    }
  }
}
</script>

<style scoped>
.conteudo-detalhamento-produto {
  width: 500px !important;
}
.w-800px {
  width: 800px;
}
.height-full {
  height: 100vh;
}
.pl-5px {
  padding-left: 5px;
}
</style>
